<script>
import { user } from 'rxfire/auth';
import Popup from './Popup.svelte';
    
    import { db } from './firebase.config.js';
import { UnsubscriptionError } from 'rxjs';

    export let id = ''
    export let hbcu = {}


    const showPopup = () => {
		open(Popup, { message: id });
	};

</script>



<div class="card" style="width: 18rem;">

  <div class="card-body">

  
  <img  src="/images/{hbcu.id}.{hbcu.img_ext}" alt={hbcu.School}  width="250" data-toggle="modal" data-target="#exampleModal-{id}"/>
    

    {#if hbcu.Details=="\"\""}
    <h5 class="card-title  text-white bg-secondary " data-toggle="modal" data-target="#exampleModal-{id}" title={hbcu.Comment}>{hbcu.School} </h5>
   

    {:else}
    <h5 class="card-title" data-toggle="modal" data-target="#exampleModal-{id}" title={hbcu.Comment}>{hbcu.School}</h5>
    {/if}

    <p class="card-text">{hbcu.Founded}</p>

  </div>
</div>



<!-- Modal -->
<div class="modal fade" id="exampleModal-{id}" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{hbcu.School}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <h6 class="card-subtitle mb-2 text-muted">Founded: <span class="text-primary">{hbcu.Founded}</span></h6>
            <h6 class="card-subtitle mb-2 text-muted">Type: <span class="text-primary">{hbcu.Type}</span></h6>          
          <h6 class="card-subtitle mb-2 text-muted">City: <span class="text-primary">{hbcu["City"]}</span></h6>          
          <h6 class="card-subtitle mb-2 text-muted">State/Territory: <span class="text-primary">{hbcu["State/Territory"]}</span></h6>          
          <h6 class="card-subtitle mb-2 text-muted">Comment: <span class="text-primary">{hbcu["Comment"]}</span></h6>          
          <h6 class="card-subtitle mb-2 text-muted">Regionally accredited: <span class="text-primary">{hbcu["Regionally accredited[3]"]}</span></h6>          
  
          <hr>
          <div>{hbcu["Details"]} </div>

          <hr>
           <div><br><small>{id}</small></div>       
          
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>

        </div>
      </div>
    </div>
  </div>

